const depositAccountRoutes = [

    {

        path: '',
        name: 'depositHome',
        component: () => import('./ListDepositAccounts.vue'),
        meta: {
            auth: true,
            title: 'Current Accounts',
            breadcrumb: 'Current Accounts',
            permission: ['view current accounts']
        }

    },

    {

        path: 'balance',
        name: 'depositBalance',
        component: () => import('./ListDepositBalance.vue'),
        meta: {
            auth: true,
            title: 'Deposits Balances',
            breadcrumb: 'Deposits Balances',
            permission: ['view current balances']
        }

    },

    {
        path: 'customer-deposits/:customerId',
        name: 'customerDeposits',
        component: () => import('./ListDepositAccounts.vue'),
        meta: {
            auth: true,
            title: 'Current Accounts',
            breadcrumb: 'Current Accounts',
            permission: ['view current accounts']
        },

    },

    {
        path: 'deposit-statement/:deposit_application_id',
        name: 'depositStatement',
        component: () => import('./DepositStatement.vue'),
        meta: {
            auth: true,
            title: 'Deposit Statement',
            breadcrumb: 'Deposit Statement',
            permission: ['view current accounts']
        },

    },

    {
        path: 'create',
        name: 'createDeposit',
        component: () => import('./CreateEditDeposit.vue'),
        meta: {
            auth: true,
            title: 'Create Deposit Account',
            breadcrumb: 'Create Deposit Account',
            permission: ['create current accounts']
        }
    },



    {
        path: ':id/edit',
        name: 'editDeposit',
        component: () => import('./CreateEditDeposit.vue'),
        meta: {
            auth: true,
            title: 'Edit Deposit Account',
            breadcrumb: 'Edit Deposit Account',
            permission: ['update current accounts']
        }
    },

    {
        name: 'viewAccountDetails',
        path: 'account-details/:depositApplicationId',
        component: () => import('./AccountDetails.vue'),
        meta: {
            auth: true,
            title: 'Account Details',
            breadcrumb: 'Account Details',
            permission: ['view current accounts']
        }
    },


    {
        path: 'delete/:id',
        name: 'deleteDeposit',
        meta: {
            auth: true,
            title: 'Delete Deposit Account',
            permission: ['delete current accounts']
        }
    },

];

export default depositAccountRoutes;
